module.exports = __webpack_public_path__ + "static/media/banner-desktop-mobile.df6156a5.jpeg";